import {RepositoryLocationRestService} from './repository-location-rest.service';
import {RepositoryLocation} from '../../../models/repository-location';
import {Service} from '../../../providers/service/service';
import {ServiceProvider} from '../../../providers';
import {mapRepositoryLocationResponseToModel} from './mappers/repository-location.mapper';

/**
 * The RepositoryLocationService class is responsible for fetching repository-location-related data from the backend
 * and mapping the responses to application models.
 */
export class RepositoryLocationService implements Service {
  private readonly locationRestService: RepositoryLocationRestService;

  constructor() {
    this.locationRestService = ServiceProvider.get(RepositoryLocationRestService);
  }

  /**
   * Retrieves the current repository location.
   *
   * @returns A promise resolving to the active repository location.
   */
  getActiveRepositoryLocation(): Promise<RepositoryLocation> {
    return this.locationRestService
      .getActiveRepositoryLocation()
      .then(mapRepositoryLocationResponseToModel);
  }
}
